import {
  AtlasBodyMain,
  AtlasColor,
  CardComponent,
  TagMolecule
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { StackAtom } from 'components/atoms/Stack.atom'

interface PalletCardOrganismProps {
  totalSKUs: number
  container: string
  location?: string
  scanned?: boolean
  customIconName?: string
  customIconColor?: string
  onClickIcon?: () => void
}

export const PalletCardOrganism = (props: PalletCardOrganismProps) => {
  const {
    totalSKUs,
    container,
    location,
    scanned = false,
    customIconName,
    customIconColor,
    onClickIcon
  } = props
  const inPickingProcess = !location

  return (
    <CardComponent>
      <StackAtom $gap={12}>
        <StackAtom
          $direction="column"
          $gap={5}
          style={{ minWidth: '150px' }}
          $justify="center"
        >
          <StackAtom $align="center">
            <TagMolecule
              bgColor="#212121"
              shape="rounded"
              icon={
                <Icon name="ic_pallet" size={18} color={AtlasColor.Neutral00} />
              }
            />

            <AtlasBodyMain style={{ fontWeight: 700 }}>
              {container}
            </AtlasBodyMain>
          </StackAtom>

          {!inPickingProcess && (
            <StackAtom $align="center">
              <TagMolecule
                bgColor="#212121"
                shape="rounded"
                icon={
                  <Icon
                    name="ic_location"
                    size={18}
                    color={AtlasColor.Neutral00}
                  />
                }
              />

              <AtlasBodyMain style={{ fontWeight: 700 }}>
                {location}
              </AtlasBodyMain>
            </StackAtom>
          )}
        </StackAtom>

        <StackAtom
          $justify="space-between"
          $align="center"
          style={{ width: '100%' }}
        >
          <StackAtom $gap={12}>
            <TagMolecule
              text={`${totalSKUs}`}
              icon={
                <Icon
                  name="ic_product"
                  size={18}
                  color={AtlasColor.Neutral00}
                />
              }
            />
            {inPickingProcess && (
              <TagMolecule
                icon={
                  <Icon
                    name="ic_picking_wip"
                    size={18}
                    color={AtlasColor.Neutral00}
                  />
                }
              />
            )}
          </StackAtom>

          {customIconName ? (
            <Icon
              size={24}
              name={customIconName}
              color={customIconColor}
              onClick={onClickIcon}
            />
          ) : (
            <Icon
              size={24}
              name={scanned ? 'ic_check_circle_fill' : 'ic_check_circle_dark'}
              color={scanned ? '#21C043' : AtlasColor.Disabled}
              onClick={onClickIcon}
            />
          )}
        </StackAtom>
      </StackAtom>
    </CardComponent>
  )
}
